export default {
  actions: {
    copied: "Copied to clipboard",
    copyFailed: "Failed to copy",
    channelStarted: "{channelName} started successfully",
    channelStartFailed: "Failed to start {channelName}",
    channelStopped: "{channelName} stopped successfully",
    channelStopFailed: "Failed to stop {channelName}",
    cacheCleared: "Iris Core cache cleared successfully",
    cacheClearFailed: "Failed to clear Iris Core cache",
  },

  tooltips: {
    copyBarcode: "Copy barcode to clipboard",
  },
};
